import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioInput from './RadioInput';
import Button from '../Buttons/Button';

// Has to be a class component because it makes use of refs
class RadioSwitch extends Component {

  render() {
    // We set the default value of disabled to be false here as otherwise not passing the disabled prop returns undefined rather than false
    const { onChange, name, leftLabel, leftValue, leftChecked, rightLabel, rightValue, rightChecked, disabled = false } = this.props;
    let radioSwitchClass;

    if (rightChecked) {
      radioSwitchClass = 'radio-switch--right-checked';
    } else if (leftChecked) {
      radioSwitchClass = 'radio-switch--left-checked';
    }

    let disabledClass;
    if (disabled) {
      disabledClass = 'radio-switch--disabled';
    }

    const handleInputClick = (e) => {
      if (disabled) {
        e.preventDefault();
      } else {
        onChange(e);
      }
    };

    const handleSwitchClick = (e) => {
      e.preventDefault();
      if (disabled === false) {
        if (leftChecked === true) {
          this.rightInput.click();
        } else {
          this.leftInput.click();
        }
      }
    };

    return (
      <div className={`radio-switch d-flex ${radioSwitchClass} ${disabledClass}`}>
        <RadioInput
          name={name}
          label={leftLabel}
          onChange={handleInputClick}
          value={leftValue}
          checked={leftChecked}
          inputRef={(input) => { this.leftInput = input; }}
          tabIndex={-1} // Don't need to be able to tab to it as button is focusable and does the same job
        />

        <Button classes="radio-switch__switch" onClick={e => handleSwitchClick(e)} faux />

        <RadioInput
          name={name}
          label={rightLabel}
          onChange={handleInputClick}
          value={rightValue}
          checked={rightChecked}
          inputRef={(input) => { this.rightInput = input; }}
          tabIndex={-1}
        />
      </div>
    );
  }
}

RadioSwitch.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  leftLabel: PropTypes.string,
  leftValue: PropTypes.string.isRequired,
  leftChecked: PropTypes.bool,
  rightLabel: PropTypes.string,
  rightValue: PropTypes.string.isRequired,
  rightChecked: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default RadioSwitch;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/RadioSwitch.js